import React from 'react';
import './Increased.css';

const Increased = () => {
  return (
    <div className="Increas-container">
      <h2 className="Increas-heading">FEATURES</h2>

      <div className="Increas-card"> 
        

        <ul className="Increas-list" data-aos="fade-down-left">
          <li><strong>Increased 40% of Injection Speed And Pressure  –</strong> Match with double alloy screw barrel,more wear-resisting,corrosion.</li>
          <li><strong>Specialized Screw For PC & TPU –</strong>Solve the problems about product become yellow and other issues.</li>
          <li><strong>SKD Distributor/Ring/Washer  –</strong> Wear-resistant & Anti-fatigue, greatly reducing the probability of cracking also improving machine lifetime.</li>
          <li><strong>Hydraulic System Upgrade –</strong>  More powerful and higher manufacturing effciency.</li>
          <li><strong>Strengthened Platen Structure –</strong>Reducing the deformation of the platen, resulting higher precision and provides long-term stable operation.</li>
        </ul>
      </div>
    </div>
  );
};

export default Increased;
